<template>
  <div class="row mb-30" v-if="documents.length">
    <div class="progress-table-wrap pt-50 full-width">
      <h2 class="text-center mb-20" v-if="title">{{ title }}</h2>
      <documents-table :documents="documentsTable" />
    </div>
  </div>
</template>

<script>
import { cntService } from "../../services/contentful/contentful.service";

import DocumentsTable from "@/components/Documents/DocumentsTable";

export default {
  name: "DocumentsInfo",
  components: {
    DocumentsTable
  },
  props: {
    documents: {
      type: Array,
      required: true,
      default: () => []
    },
    title: {
      type: String,
      required: true,
      default: ""
    }
  },
  data: () => ({
    documentsTable: []
  }),
  created() {
    this.updateData();
  },
  updated() {
    this.updateData();
  },

  methods: {
    async updateData() {
      this.documents.length &&
        (await cntService
          .setEntryId(this.documents.join(","))
          .getMultipleEntriesByIds()
          .then(docs => {
            this.documentsTable = docs.items.map(dcs => dcs.fields);
          }));
    }
  }
};
</script>

<style scoped></style>
